import { gql, watchQuery } from '@/services/apollo'

const GET_ADAPTERS = gql`
  query AdapterPage($input: AdapterPageInput!) {
    adapterPage(input: $input) {
      adapter {
        id
        type
        configVariables
      }
      totalCount
    }
  }
`

export default {
  getAdapters () {
    return watchQuery({ query: GET_ADAPTERS, variables: { input: { limit: 0, offset: 0 } } })
  },
}
